// severity style，根据severity进行切换 AWS-278
export const getSeverityStyle = (severity: string) => {
  /**
     * Mild：蓝色

      Moderate：黄色

      Severe：红色
     */
  const defaultStyle = "";
  return (
    {
      Mild: "text-blue-700",
      Moderate: "text-yellow-700",
      Severe: "text-red-700",
    }[severity] || defaultStyle
  );
};
